export const gameConstants = {
    LOAD_GAME_PAGE: 'LOAD_GAME_PAGE',
    LAUNCH_GAME: 'LAUNCH_GAME',
};
